/* eslint-disable max-len */
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message, Form } from 'antd';
import businessTypeAction from '@state/businessType/actions';
import devicesApi from '@api/devicesApi';

function CreateBusinessType() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const dataInit = useSelector(({ businessType }) => businessType.createNewBusinessType);
  const idToEdit = useSelector(({ businessType }) => businessType.businessTypeIdToEdit);
  const [dataForm, setDataForm] = useState(dataInit);
  const [form] = Form.useForm();
  // const [dataFormOld, setDataFormOld] = useState(dataInit);

  const [loadingForm, setLoadingForm] = useState(false);
  const currentUserRol = useSelector(({ user }) => user.role);

  const abortC = new AbortController();
  const { signal } = abortC;

  const defaultData = {
    id: '',
    name: '',
    description: '',
    latitude: '',
    longitude: '',
    type: '',
  };

  const onFinish = useCallback((values) => { // submit: create business type or edit business type

    if (!idToEdit) { //  create business type

      const formData = new FormData();
      if (dataInit.id) {

        formData.append('id', dataInit.id);

      }
      if (dataInit.logo_file && dataInit.logo_file !== '') {

        formData.append('logo_file', dataInit.logo_file);

      }
      formData.append('name', dataInit.name);
      formData.append('description', dataInit.description);
      formData.append('latitude', dataInit.latitude);
      formData.append('longitude', dataInit.longitude);
      formData.append('type', dataInit.type);

      setLoadingForm(true);
      devicesApi.createBusinessType({ signal, formData })
        .then(async (response) => {

          if (dataInit.type === 'Comunidades') {

              const datosCommunities = {
                frt: dataInit.frt,
                settlement_cycle: dataInit.settlement_cycle,
                type: dataInit.type_communitie,
                business_type_id: response.id,
              };

              try {

               await devicesApi.createBusinessTypeCommunitie({ signal, body: datosCommunities });

} catch (error) {

                console.log('error createBusinessTypeCommunitie', error);

}

}

          setLoadingForm(false);
          message.success(t('views.create_business_type.form.create_success'));
          setDataForm(defaultData);
          dispatch(businessTypeAction.setCreateEditBusinessType(defaultData));
          dispatch(businessTypeAction.setBusinessTypeIdEdit(null));

          history.goBack();

        })
        .catch((resError) => {

          setLoadingForm(false);
          console.log('error: ', resError);
          message.error(resError?.data?.detail[0].msg || t('views.create_business_type.form.create_error'));

        });

    } else { // Edit business type

      const formData = new FormData();
      if (dataInit.id) {

        formData.append('id', dataInit.id);

      }
      if (dataInit.logo_file && dataInit.logo_file !== '') {

        formData.append('logo_file', dataInit.logo_file);

      }
      formData.append('name', dataInit.name);
      formData.append('description', dataInit.description);
      formData.append('latitude', dataInit.latitude);
      formData.append('longitude', dataInit.longitude);
      formData.append('type', dataInit.type);

      setLoadingForm(true);
      devicesApi.editBusinessType({ signal, id: idToEdit, formData })
        .then(async (response) => {

          if (dataInit.type === 'Comunidades') {

              const datosCommunities = {
                frt: dataInit.frt,
                settlement_cycle: dataInit.settlement_cycle,
                type: dataInit.type_communitie,
              };

              try {

              await devicesApi.updateBusinessTypeCommunitie({ signal, body: datosCommunities, id: dataInit.community_id });

} catch (error) {

                console.log('error updateBusinessTypeCommunitie', error);

}

}

          setLoadingForm(false);
          message.success(t('views.create_business_type.form.edit_success'));
          setDataForm(defaultData);
          dispatch(businessTypeAction.setCreateEditBusinessType(defaultData));
          dispatch(businessTypeAction.setBusinessTypeIdEdit(null));

          // eslint-disable-next-line

          history.push('/dispositivos/negocio');
          // history.goBack();

})
        .catch((resError) => {

          //  eslint-disable-next-line
          setLoadingForm(false);
          console.log('error: ', resError);
          message.error(resError?.data?.detail[0].msg || t('views.create_business_type.form.edit_error'));

});

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);
      // if (key === 'name') valueName = data;
      setDataForm({ ...dataForm, [key[0]]: data[0] });
      // eslint-disable-next-line max-len
      dispatch(businessTypeAction.setCreateEditBusinessType({ ...dataForm, [key[0]]: data[0] }));

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const cancelCreateEditBusinessType = useCallback(() => {

    // history.push('/dispositivos/negocio');
    history.goBack();

  }, []);

  const fileRequest = useCallback(
    ({ file, onSuccess, onProgress }) => {

      let progress = 0;
      const interval = setInterval(() => {

        progress += 10;

        onProgress({ percent: progress });
        if (progress === 100) {

          onSuccess('ok');
          clearInterval(interval);
          setDataForm({ ...dataForm, logo_file: file });
          dispatch(businessTypeAction.setCreateEditBusinessType({ ...dataForm, logo_file: file }));
          progress = 0;

        }

      }, 150);

    }, [dispatch, dataForm, setDataForm],
  );

  const changeFile = (info) => {

    if (info.file.status === 'done') {

      message.success(`${info.file.name} file uploaded successfully`);

    } else if (info.file.status === 'error') {

      message.error(`${info.file.name} file upload failed.`);

    }

  };
   // eslint-disable-next-line
   const clearType = (value) => { 

    setDataForm({
      ...dataForm,
      type: value,
      type_communitie: '',
      settlement_cycle: '',
      frt: '',
    });

    // Actualiza los valores de los campos del formulario
    form.setFieldsValue({
      ...dataForm,
      type: value,
      type_communitie: '',
      settlement_cycle: '',
      frt: '',
    });

};

  useEffect(() => { // mount component

    if (!idToEdit) { // Validate is edit

      if (location.pathname === '/dispositivos/negocio/tipo-negocio') {

        history.push('/dispositivos/negocio/crear-negocio');

      }

    }

    return function cleanUp() {

      dispatch(businessTypeAction.setCreateEditBusinessType(defaultData));
      dispatch(businessTypeAction.setBusinessTypeIdEdit(null));

    };
    // eslint-disable-next-line
  }, [idToEdit]);

  useEffect(() => { // mount component

    if (!idToEdit && location.pathname === '/dispositivos/negocio/tipo-negocio') {

          // If trying to edit without idToEdit, redirect to tipo-negocio
          history.push('/dispositivos/negocio');

} else if (!idToEdit && currentUserRol !== 'Superadmin') {

          // If trying to create without idToEdit and not Superadmin or Admin, redirect to tipo-negocio
          history.push('/dispositivos/negocio');

}
    return function cleanUp() { // clean state in redux

      dispatch(businessTypeAction.setCreateEditBusinessType(defaultData));
      dispatch(businessTypeAction.setBusinessTypeIdEdit(null));

    };
  // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditBusinessType,
    changeFile,
    fileRequest,
    loadingForm,
    form,
    clearType,
  };

}

export default CreateBusinessType;
